import styled from "@emotion/styled";

// how does this compare to FormRow?
// does it supercede it?
export const FieldLayoutContainer = styled.div<{ horizontal?: boolean }>`
  display: inline-flex;
  flex-direction: ${({ horizontal }) => (horizontal ? "row" : "column")};
  align-items: baseline;
  justify-content: space-around;
  > div {
    margin-left: 7.5px;
    margin-right: 7.5px;
    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-left: 0;
    }
  }
`;
